/**
 * Pre-compiled fr-FR messages for Select
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { clearSelection: `Effacer la sélection` };
